import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { LOADING_SPINNER_SIZE_MEDIUM } from 'constants/style';
import { ColorType } from 'models/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
    },
  }),
);

interface Props {
  size?: number;
  color?: ColorType;
}

const Spinner: React.FC<Props> = (props) => {
  const { size = LOADING_SPINNER_SIZE_MEDIUM, color } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <CircularProgress size={size} color={color} />
    </div>
  );
};

export default Spinner;
